<!--
 * @description: 维修  维修检测
 * @param: 
 * @return: 
-->
<template>
  <div class="user-management-container">
    <tabel-panel
      ref="tabel"
      :rowTemplate="rowTemplate"
      api="RepairDetectSearch"
      :condition="conditionData"
      editType="pop"
      :autoSearch="true"
      :showCancelButton="false"
      @popConfirmButtonClick="popConfirmButtonClick"
      :clickRowSelected="false"
      :popToCustomer="true"
    >
      <template v-slot:tabelTitleLeft>
        <div>维修检测</div>
      </template>

      <template v-slot:condition style="height: 200px">
        <text-field
          v-model:value="conditionData.compid"
          labelText="客户:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguName"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.BrandId"
          labelText="品牌名称:"
          :clearable="true"
          type="select"
          :selectRemoteSearchData="selectOuguBrand"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.ProductId"
          labelText="产品类别:"
          ref="selectChild"
          :clearable="true"
          :type="selectChildData == null ? 'select' : 'selectChild'"
          :selectChildData="selectChildData"
          :selectRemoteSearchData="selectOuguNameProduct"
          class="condition-container-input"
        >
        </text-field>
        <text-field
          v-model:value="conditionData.ModelNoId"
          labelText="产品型号:"
          ref="selectChildMoid"
          :clearable="true"
          :type="selectChildData == null ? 'select' : 'selectChild'"
          :selectChildData="selectChildMoid"
          :selectRemoteSearchData="selectOuguNameModelSelect"
          class="condition-container-input"
        >
        </text-field>

        <!-- <text-field labelText="品牌名称:" class="condition-container-input">
					<template #default="">
						<el-select v-model="conditionData.BrandId" clearable @change="handlePinP" placeholder="请选择">
							<el-option v-for="item in options.pinP" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</template>
				</text-field> -->

        <!-- <text-field labelText="产品类别:" class="condition-container-input">
					<template #default="">
						<el-select v-model="conditionData.ProductId" @change="handlechanPType" clearable
							placeholder="请选择">
							<el-option v-for="item in options.chanPType" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</template>
				</text-field> -->

        <!-- <text-field labelText="产品型号:" class="condition-container-input">
					<template #default="">
						<el-select v-model="conditionData.ModelNoId" clearable placeholder="请选择">
							<el-option v-for="item in options.chanPNum" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</template>
				</text-field> -->

        <text-field
          v-model:value="conditionData.sn"
          labelText="SN号:"
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.staetime"
          type="date"
          labelText="申请起始日期:"
          clearable
          class="condition-container-input"
        >
        </text-field>

        <text-field
          v-model:value="conditionData.endtime"
          type="date"
          labelText="申请截至日期:"
          clearable
          class="condition-container-input"
        >
        </text-field>
      </template>
      <template v-slot:Detect="$opData">
        <div class="opration">
          <div class="style-aaa" @click="handlePop($opData.data.row)">检测</div>
          <!-- <search-button class="item" @buttonClick="handlePop($opData.data.row)"></search-button> -->
        </div>
      </template>
      <template v-slot:oprator="$opData">
        <div class="style-aaa" @click="delSingleUser($opData.data)">删除</div>
        <!-- <del-border :useConfirm="true" comfirmMessage="确定删除吗？" comfirmOkText="确定" comfirmCancelText="取消"
					@buttonClick="delSingleUser($opData.data)"></del-border> -->
      </template>
    </tabel-panel>
    <pop-dialog
      id="saveBOX"
      @confirmClick="listDataSave"
      v-if="saveBOX"
      ref="getMenuList"
      :meta="popDialogList"
      detailShowType="data"
      textButtons="保存"
      @dialogClose="saveBOX = false"
    >
      <template v-slot="idData">
        <div class="saveBox">
          <el-form
            :model="RepairDetectEdit"
            :rules="rules"
            ref="saveEdit"
            label-width="85px"
          >
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="RMA:" prop="RMANo">
                    <el-input
                      v-model="saveEdit.RMANo"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="客户名称:" prop="CompName">
                    <el-input
                      disabled
                      v-model="saveEdit.CompName"
                      placeholder=""
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="联系人:" prop="LinkMan">
                    <el-input
                      disabled
                      v-model="saveEdit.LinkMan"
                      placeholder=""
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="电话:" prop="TelNo">
                    <el-input
                      v-model="saveEdit.TelNo"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="邮编:" prop="PostNo">
                    <el-input
                      v-model="saveEdit.PostNo"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="请领人:" prop="AssignName">
                    <el-input
                      v-model="saveEdit.AssignName"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="品牌:" prop="BrandName">
                    <el-input
                      v-model="saveEdit.BrandName"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="产品:" prop="ProCateName">
                    <el-input
                      v-model="saveEdit.ProCateName"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="型号:" prop="ModelNoName">
                    <el-input
                      v-model="saveEdit.ModelNoName"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="SN号:" prop="SerialNoName">
                    <el-input
                      v-model="saveEdit.SerialNoName"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="递送方式:" prop="noexp">
                    <el-select
                      v-model="RepairDetectEdit.noexp"
                      placeholder="请选择寄送方式"
                      size="small"
                    >
                      <el-option
                        v-for="(item, index) in selectData"
                        :key="index"
                        :label="item.Name"
                        :value="item.Id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="症状信息:" prop="CusApp">
                    <el-input
                      v-model="saveEdit.CusApp"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="14">
                <div class="grid-content bg-purple">
                  <el-form-item label="附件:" prop="AttachName">
                    <el-input
                      v-model="saveEdit.AttachName"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="9">
                <div class="grid-content bg-purple">
                  <el-form-item
                    label="实际症状类型:"
                    label-width="100px"
                    prop="actills"
                  >
                    <el-select
                      v-model="RepairDetectEdit.actills"
                      placeholder="请选择症状"
                      size="small"
                    >
                      <el-option
                        v-for="item in ModelIllData"
                        :key="item.id"
                        :label="item.Name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="14">
                <div class="grid-content bg-purple">
                  <el-form-item label="备注:" prop="IllDesc">
                    <el-input
                      v-model="saveEdit.IllDesc"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="10">
                <div class="grid-content bg-purple grid-Label">
                  <el-form-item
                    label-width="100px"
                    label="实际测试结果:"
                    prop="DetectDesc"
                    :rules="[
                      {
                        required: true,
                        message: '请输入测试结果',
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      v-model="RepairDetectEdit.DetectDesc"
                      placeholder=""
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-form>
          <div></div>
        </div>
      </template>
    </pop-dialog>
    <pop-dialog
      id="returnFactory"
      @confirmClick="listDataSave"
      v-if="returnFactory"
      ref="getMenuFactory"
      :meta="popDialogList"
      detailShowType="data"
      textButtons="保存"
      @dialogClose="returnFactory = false"
    >
      <template v-slot="idData">
        <div class="saveBox">
          <el-form
            :model="RepairDetectEdit"
            :rules="rules"
            ref="saveEdit"
            label-width="85px"
          >
            <el-row :gutter="20">
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="RMA:" prop="RMANo">
                    <el-input
                      v-model="saveEdit.RMANo"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="SN号:" prop="SerialNoName">
                    <el-input
                      v-model="saveEdit.SerialNoName"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="请领人:" prop="AssignName">
                    <el-input
                      v-model="saveEdit.AssignName"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="品牌:" prop="BrandName">
                    <el-input
                      v-model="saveEdit.BrandName"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="产品:" prop="ProCateName">
                    <el-input
                      v-model="saveEdit.ProCateName"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="型号:" prop="ModelNoName">
                    <el-input
                      v-model="saveEdit.ModelNoName"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="16">
                <div class="grid-content bg-purple">
                  <el-form-item label="客户名称:" prop="CompName">
                    <el-input
                      disabled
                      v-model="saveEdit.CompName"
                      placeholder=""
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="电话:" prop="TelNo">
                    <el-input
                      v-model="saveEdit.TelNo"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="返厂名称:" prop="noexp">
                    <el-select
                      v-model="saveEdit.FactoryBack_Id"
                      placeholder="请选择寄送方式"
                      size="small"
                    >
                      <el-option
                        v-for="(item, index) in FactoryName"
                        :key="index"
                        :label="item.Name"
                        :value="item.FactoryBack_Id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="厂家报价:" prop="noexp">
                    <el-input
                      v-model="saveEdit.FactoryPrice"
                      placeholder=""
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>

              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <el-form-item label="返厂RMA:" prop="CusApp">
                    <el-input
                      v-model="saveEdit.MotoRMA"
                      placeholder=""
                      disabled
                      size="small"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="14">
                <div class="grid-content bg-purple">
                  <el-form-item label="备注:" prop="AttachName">
                    <el-input
                      v-model="saveEdit.Appendix"
                      placeholder=""
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="14">
                <div class="grid-content bg-purple">
                  <el-form-item label="实际检测结果:" prop="DetectDesc">
                    <el-input
                      v-model="saveEdit.DetectDesc"
                      type="textarea"
                      :rows="2"
                      placeholder=""
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="14">
                <div class="grid-content bg-purple">
                  <el-form-item label="厂家维修方法:" prop="FactRepairMethod">
                    <el-input
                      type="textarea"
                      :rows="2"
                      v-model="saveEdit.FactRepairMethod"
                      placeholder=""
                      size="small"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-form>
          <div></div>
        </div>
      </template>
    </pop-dialog>
  </div>
</template>

<script>
import textField from "@/components/textField.vue";
import searchButton from "@/components/searchButton.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import tableApi from "@/api/tabel.js";
import {
  ChangeRepairDetailStateById,
  RepairDetectEditChangeState,
  RepairDetectEditBack,
} from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";
import delBorder from "@/components/delBorder.vue";
import { ElMessageBox } from "element-plus";

export default {
  name: "RepairDetec",
  components: {
    textField,
    delBorder,
    tabelPanel,
    popDialog,
    searchButton,
  },
  data() {
    return {
      options: {
        pinP: [],
        chanPType: [],
        chanPNum: [],
      },

      conditionData: {
        compid: null,
        BrandId: null,
        ProductId: null,
        ModelNoId: null,
        sn: null,
        staetime: null,
        endtime: null,
        rma: null,
      },
      inputValue: "明细",
      activeName: "second",
      loadShow: false,
      saveBOX: false,
      returnFactory: false,
      rowTemplate: [
        {
          headerLabel: "填报人",
          width: 100,
          dataIndex: "AddUser",
        },
        {
          headerLabel: "维修状态",
          dataIndex: "State",
        },
        {
          headerLabel: "递送方式",
          sortable: true,
          width: 100,
          dataIndex: "NotExpressName",
        },
        {
          headerLabel: "产品",
          sortable: true,
          dataIndex: "ProCateName",
        },
        {
          headerLabel: "型号",
          sortable: true,
          dataIndex: "ModelNoName",
        },
        {
          headerLabel: "SN号",
          sortable: true,
          width: 240,
          dataIndex: "SerialNoName",
          dataRender: (v, { $index, column, row }) => {
            return (
              '<span style="color:' +
              (row.Distinguish == 1
                ? "green"
                : row.Distinguish == 2
                ? "blue"
                : row.Distinguish == 3
                ? "red"
                : "") +
              '">' +
              v +
              ""
            );
          },
        },
        {
          headerLabel: "症状信息",
          width: 70,
          dataIndex: "CusApp",
        },
        {
          headerLabel: "备注",
          width: 100,
          dataIndex: "IllDesc",
        },
        {
          headerLabel: "附件",
          width: 50,
          dataIndex: "AttachName",
        },
        {
          headerLabel: "维修中心", //0
          width: 100,
          dataIndex: "ServerName",
        },
        {
          headerLabel: "客户名称", //0
          width: 240,
          sortable: true,
          dataIndex: "CompName",
        },
        {
          headerLabel: "接收日期",
          width: 120,
          dataIndex: "ReciveDate",
        },
        {
          headerLabel: "维修周期",
          width: 100,
          dataIndex: "RepairCycle",
        },
        {
          headerLabel: "检测",
          slot: "Detect",
          width: 70,
        },
        {
          headerLabel: "删除",
          slot: "oprator",
          width: 70,
        },
      ],
      saveEdit: null,
      selectData: [],
      FactoryName: null,
      ModelIllData: null,
      RepairDetectEdit: {
        id: 0, //Int	维修信息id	是
        DetectDesc: "", //String	实际检测结果	是
        actills: "", //String	实际症状类型	是
        noexp: "", //String	递送方式	是
      },
      rules: {
        noexp: [
          {
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        actills: [
          {
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
      },
      selectChildData: null,
      selectChildMoid: null,
    };
  },
  updated() {
    const keys = Object.keys(this.conditionData);
    keys.forEach((item) => {
      this.conditionData[item] = null;
    });
  },
  mounted() {
    this.getPinPData();
  },
  methods: {
    // 获取品牌名称数据
    async getPinPData() {
      let {
        data: { list },
      } = await tableApi.BrandSelect();

      this.options.pinP = list?.map((item) => ({
        label: item.Name,
        value: item.id,
      }));
    },
    async handlePinP(v) {
      this.options.chanPType = [];
      this.options.chanPNum = [];
      this.conditionData.ProductId = "";
      this.conditionData.ModelNoId = "";
      let {
        data: { list },
      } = await tableApi.ProductSelect({ Bid: v });
      this.options.chanPType = list?.map((item) => ({
        label: item.Name,
        value: item.id,
      }));
    },
    async handlechanPType(v) {
      this.options.chanPNum = [];
      this.conditionData.ModelNoId = "";
      let {
        data: { list },
      } = await tableApi.modelSelect({ ProductCategoryId: v });
      this.options.chanPNum = list?.map((item) => ({
        label: item.Name,
        value: item.id,
      }));
    },
    /**
     * @description: 获取客户名称
     * @param {*}
     * @return {*}
     */
    async selectOuguName() {
      let source = await tableApi.CompanyInfo();
      if (source.code == 0) {
        let data = source.data.list.map(({ Company_Id, CompName }) => {
          return {
            label: CompName,
            value: Company_Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    /**
     * @description: 三级联动一级数据
     * @param {*}
     * @return {*}
     */
    async selectOuguBrand() {
      let source = await tableApi.BrandSelect();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    /**
     * @description: 三级联动二级数据
     * @param {*} Bid  --一级数据id
     * @return {*}
     */
    async selectOuguNameProduct(Bid) {
      let source;
      if (this.selectChildData == null) {
        source = await tableApi.ProductSelect();
      } else {
        source = await tableApi.ProductSelect({ Bid });
      }
      this.selectChildData = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    /**
     * @description: 三级联动三级数据
     * @param {*} ProductCategoryId---二级数据id
     * @return {*}
     */
    async selectOuguNameModelSelect(ProductCategoryId) {
      let source;
      if (this.selectChildMoid == null) {
        source = await tableApi.modelSelect();
      } else {
        source = await tableApi.modelSelect({ ProductCategoryId });
      }
      this.selectChildMoid = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 获取表格数据
    reloadData() {
      this.$refs.tabel.reloadData();
    },
    // 删除
    delSingleUser({ row }) {
      let { Id: id } = row;
      ElMessageBox.confirm("确定删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ChangeRepairDetailStateById({ id }).then((data) => {
            if (data.code == 0) {
              successMsg(data.message);
              this.reloadData();
            } else {
              errMsg(data.message);
            }
          });
        })
        .catch(() => {});
    },
    // 返厂名称
    returnFactoryName() {
      tableApi.BackFactory().then((data) => {
        if (data.code == 0) {
          this.FactoryName = data.data.list.map((i) => {
            return { FactoryBack_Id: i.Id, Name: i.Name };
          });
        } else {
          return console.log(data.code);
        }
      });
    },
    // 维修
    handlePop(row) {
      this.saveEdit = row;
      this.returnFactoryName();
      this.addModelIllSelect(row.ProCate_Id);
      console.log("this.saveEdit", this.saveEdit);
      if (this.saveEdit.State == "返厂返回") {
        this.returnFactory = true;
        this.$nextTick(() => {
          this.$refs.getMenuFactory.showPopDialog(
            { row },
            "编辑服务记录",
            "slot"
          );
        });
      } else {
        // 递送方式
        this.RepairDetectEdit.noexp = "";
        // 实际症状类型
        this.RepairDetectEdit.actills = "";
        // 实际测试结果
        this.RepairDetectEdit.DetectDesc = "";
        this.saveBOX = true;
        this.selectTransFangshi();
        this.$nextTick(() => {
          this.$refs.getMenuList.showPopDialog(
            { row },
            "维修检测编辑信息",
            "slot"
          );
        });
      }
    },
    // 寄送方式 TransFangshi
    selectTransFangshi() {
      tableApi.TransFangshi().then((data) => {
        if (data.code == 0) {
          console.log("@", data.data.list);
          this.selectData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    // 产品症状类型
    addModelIllSelect(ProductCategoryId) {
      tableApi.ModelIllSelect({ ProductCategoryId }).then((data) => {
        if (data.code == 0) {
          this.ModelIllData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    // 保存api
    listDataSave({ slotData }) {
      console.log(slotData.row);
      if (slotData.row.State === "已接收") {
        this.$refs["saveEdit"].validate((valid) => {
          if (valid) {
            this.RepairDetectEdit.id = slotData.row.Id;
            let parms = this.RepairDetectEdit;
            RepairDetectEditChangeState(parms).then((data) => {
              if (data.code == 0) {
                this.saveBOX = false;
                successMsg(data.message);
                this.reloadData();
              } else {
                errMsg(data.message);
              }
            });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      } else {
        RepairDetectEditBack({ Id: slotData.row.Id }).then((data) => {
          if (data.code == 0) {
            this.returnFactory = false;
            successMsg(data.message);
            this.reloadData();
          } else {
            errMsg(data.message);
          }
        });
      }
    },
    //弹层事件
    popConfirmButtonClick({ slotData }) {
      console.log(slotData);
    },
    // handleClick(tab, event) {
    // 	this.loadShow = false
    // }
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

#suerSwitch .el-switch__core {
  width: 26px;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: red;
}

.user-management-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  align-content: center;
  @include background_color("user-management-bg-color");

  .del {
    margin-left: 10px;
  }

  .condition-container-input {
    width: 270px;
  }

  // .opration {
  // 	height: 100%;
  // 	width: 100%;
  // 	display: flex;
  // 	justify-content: center;
  // 	align-items: center;
  // 	align-content: center;

  // 	.item {
  // 		&:nth-child(n+1) {
  // 			margin-left: 10px;
  // 		}
  // 	}
  // }
  .menuPowerBOX {
    .el-button--default {
      width: 90px;
      height: 30px;
      color: #ffffff;
      background: rgb(100, 134, 232);
      border-radius: 4px;
    }

    .item {
      height: 30px;
      color: #ffffff !important;
      padding: 10px 15px !important;
      background: rgb(100, 134, 232) !important;
    }
  }

  ::v-deep .el-table--scrollable-x .el-table__body-wrapper {
    overflow: auto !important;
  }

  ::v-deep .el-table__fixed-right-patch {
    background-color: #f5f7fa !important;
  }

  .el-row {
    margin-bottom: 16px;
  }

  .saveBox {
    padding-bottom: 20px;
  }
}

.el-select-dropdown__item {
  width: auto;
  padding: 0 20px;
  text-align: left;
}
.style-aaa {
  cursor: pointer;
  color: rgb(100, 134, 232);
  // style="{cursor:'pointer',color:'rgb(100,134,232)'}"
}
</style>
